import script from "./NumberPlateInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberPlateInput.vue?vue&type=script&setup=true&lang=ts"

import "./NumberPlateInput.vue?vue&type=style&index=0&id=9d0f8542&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d0f8542"]])

export default __exports__